import React from 'react';
import { Sun, Moon } from 'lucide-react';
import NeoPrismaAcademyLogo from '@/components/branding/NeoPrismaAcademyLogo';

const FooterSection = () => {
  const [isDark, setIsDark] = React.useState(
    document.documentElement.classList.contains('dark')
  );

  const toggleTheme = () => {
    const html = document.documentElement;
    const newIsDark = !isDark;
    
    if (newIsDark) {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
    
    setIsDark(newIsDark);
    localStorage.setItem('theme', newIsDark ? 'dark' : 'light');
  };

  const quickAccessLinks = [
    { label: 'Dashboard', href: '/dashboard' },
    { label: 'AI Tutor', href: '/ai-tutor' },
    { label: 'Interview Prep', href: '/advanced-features' },
    { label: 'My Courses', href: '/courses' }
  ];


  return (
    <footer className="bg-muted/30 border-t border-border py-12">
      <div className="container mx-auto px-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 mb-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <NeoPrismaAcademyLogo size="md" />
            <p className="text-sm text-muted-foreground mt-4">
              Employee learning hub powered by AI
            </p>
          </div>

          {/* Quick Access */}
          <div>
            <h3 className="font-semibold mb-4 text-sm uppercase tracking-wider border-b border-accent/30 pb-2 inline-block">
              Quick Access
            </h3>
            <ul className="space-y-2">
              {quickAccessLinks.map((link) => (
                <li key={link.label}>
                  <a 
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-accent hover:translate-x-1 inline-block transition-all duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © 2025 Neo Prism Academy. All rights reserved. • Platform v2.0
          </p>
          
          <div className="flex items-center gap-4">
            <button
              onClick={toggleTheme}
              className="p-2 rounded-lg hover:bg-muted transition-colors"
              aria-label="Toggle theme"
            >
              {isDark ? (
                <Sun className="w-5 h-5 text-muted-foreground" />
              ) : (
                <Moon className="w-5 h-5 text-muted-foreground" />
              )}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
